import { useCallback } from 'react';

import { useEstateWaterfallContext } from '../contexts/estateWaterfall.context';
import { CreateNewGroupFormShape } from './CreateNewGroupModal';

/**
 * Create node group via local state only (no GraphQL mutations).
 * All changes are batched and persisted on Save.
 */
export function useCreateNodeGroup() {
  const { dispatch } = useEstateWaterfallContext();

  const createNodeGroup = useCallback(
    async (formData: CreateNewGroupFormShape) => {
      const {
        description,
        displayName,
        namespace,
        nodeIds,
        applyToAllSections,
        componentType,
        hideGroupContents,
      } = formData;

      // Dispatch action to update local state only - no GraphQL mutations
      dispatch({
        type: 'COMPLETE_NODE_GROUP_CREATION',
        displayName: displayName ?? '',
        description: description ?? undefined,
        namespace: namespace ?? '',
        nodeIds,
        applyToAllSections,
        componentType,
        hideGroupContents,
      });

      // Return undefined since we don't have updated waterfall data from the server
      return undefined;
    },
    [dispatch]
  );

  return { createNodeGroup };
}
